import 'element-closest';

export class PublicityImageBlock {
    constructor() {
        // ------------------------------------------------------------------------ //
        // ------- Publicity block's 'view more' & 'view less' button logic ------- //
        // ------------------------------------------------------------------------ //
        if (document.querySelector('.publicity-view-more-js')) {
            let viewMoreNodeList = document.querySelectorAll('.publicity-view-more-js');
            let viewMoreArray = Array.prototype.slice.call(viewMoreNodeList);

            viewMoreArray.forEach(function (viewMoreBtn) {
                viewMoreBtn.addEventListener('click', function () {
                    let expandableSection = viewMoreBtn.closest('.block-body').querySelector('.publicity-items-remaining');

                    if (viewMoreBtn.dataset.isExpanded == 'false') {
                        // Show all items
                        expandableSection.classList.remove('hidden');

                        // Swap "View More" button text with "View Less"
                        viewMoreBtn.innerHTML = 'View Less Images';
                        viewMoreBtn.setAttribute('data-is-expanded', 'true'); 
                    }
                    else {
                        // Hide extra items
                        expandableSection.classList.add('hidden');

                        // Swap "View Less" button text with "View More"
                        viewMoreBtn.innerHTML = 'View More Images';
                        viewMoreBtn.setAttribute('data-is-expanded', 'false');
                    }
                })
            })
        }

        // ------------------------------------------------------------ //
        // ------- Publicity block's carousel counter placement ------- //
        // ------------------------------------------------------------ //
        if (document.querySelector('.publicity-mobile-view-js')) {
            let publicityCarouselNodeList = document.querySelectorAll(".publicity-mobile-view-js");
            let publicityCarouselArray = Array.prototype.slice.call(publicityCarouselNodeList);

            publicityCarouselArray.forEach(function (carousel) {
                let publicityCarouselSlidesNodeList = carousel.querySelectorAll('.swiper-slide');
                let publicityCarouselSlidesArray = Array.prototype.slice.call(publicityCarouselSlidesNodeList);

                publicityCarouselSlidesArray.forEach(function (slide) {
                    let slideCounter = slide.dataset.swiperCounter;
                    let slideCounterCaption = slide.querySelector('.publicity-item-counter-js');

                    slideCounterCaption.innerHTML = slideCounter;
                })
            })
        }         
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/publicity-image-block.ts